<app-section-header
    [title]="sectionDescription.title"
    [description]="sectionDescription.description"
></app-section-header>
<div class="mb-4">
    <app-color-picker label="Background Color" formControlName="backgroundColor" />
</div>
